import firebase from '../../firebase-integration';

const makeBlob = async (fileURL: string) => {
  return await fetch(fileURL).then(r => r.blob());
};

export const uploadPostImages = async (file: string, filename: string) => {
  try {
    const user = firebase.auth().currentUser;
    const storageRef = firebase.storage().ref();
    const blob = await makeBlob(file);
    const splitupFileName = filename.split('.');
    const fileType = splitupFileName[splitupFileName.length - 1];
    const snapshot = await storageRef.child(`${user?.uid}/post_images/${filename}`).put(blob);
    const downloadURL = await snapshot.ref.getDownloadURL();
    const index = downloadURL.indexOf(fileType) - 1;
    const newDownloadURL =
      // tslint:disable-next-line:prefer-template
      downloadURL.substring(0, index) +
      '_400x400'
      + downloadURL.substring(index, downloadURL.length).replace(fileType, 'jpeg');
    return newDownloadURL;
  } catch (error) {
    throw new Error('Error Saving Image to Storage');
  }
};

export const removeImage = async (filename: string) => {
  try {
    const storageRef = firebase.storage();
    await storageRef.refFromURL(filename).delete();
  } catch (error) {
    console.log(error);
    throw new Error('Error deleting Image from Storage');
  }
};

export const uploadProfileImages = async (file: any, filename: string) => {
  try {
    const user = firebase.auth().currentUser;
    const storageRef = firebase.storage().ref();
    const blob = await makeBlob(file);

    if (!user) {
      throw new Error('no user is signed in');
    }
    const snapshot = await storageRef.child(`${user.uid}/profile_images/${filename}`).put(blob);
    const downloadURL =  await snapshot.ref.getDownloadURL();
    const splitupFileName = filename.split('.');
    const fileType = splitupFileName[splitupFileName.length - 1];
    const index = downloadURL.indexOf(fileType) - 1;
    const newDownloadURL =
      // tslint:disable-next-line:prefer-template
      downloadURL.substring(0, index) +
      '_400x400'
      + downloadURL.substring(index, downloadURL.length).replace(fileType, 'jpeg')
    ;
    window.setTimeout(() => {}, 5000);
    return newDownloadURL;
  } catch (error) {
    console.log(error);
    throw new Error('Error adding Profile Image');
  }
};
